"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPasswordSchema = exports.forgotPasswordSchema = exports.magicLinkRequestSchema = exports.loginSchema = void 0;
const zod_1 = require("zod");
exports.loginSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string().min(1),
});
exports.magicLinkRequestSchema = zod_1.z.object({ email: zod_1.z.string().email() });
exports.forgotPasswordSchema = zod_1.z.object({ email: zod_1.z.string().email() });
exports.resetPasswordSchema = zod_1.z.object({ token: zod_1.z.string().min(1), newPassword: zod_1.z.string().min(8) });
//# sourceMappingURL=auth.js.map